/**
 * Auswahllisten für Zeitzone und Währung eines Workspace. Aus dem Browser (`Intl`), damit niemand
 * eine Kennung abtippt; der Server prüft trotzdem selbst. Zeitzonen ohne Region („UTC“) fehlen,
 * weil der Server sie ablehnt. Ein gespeicherter Wert, den der Browser nicht kennt, bleibt
 * wählbar — sonst zeigte das Formular still einen anderen Wert an.
 */
export interface CurrencyOption {
  value: string;
  label: string;
}

const FALLBACK_TIME_ZONES = ['Europe/Berlin', 'Europe/Vienna', 'Europe/Zurich'];
const FALLBACK_CURRENCIES = ['CHF', 'EUR', 'GBP', 'USD'];

export function timeZoneOptions(current?: string | null): string[] {
  const zones = supported('timeZone', FALLBACK_TIME_ZONES).filter((zone) => zone.includes('/'));
  return withCurrent(zones, current);
}

export function currencyOptions(current?: string | null): CurrencyOption[] {
  const names = currencyNames();
  return withCurrent(supported('currency', FALLBACK_CURRENCIES), current?.toUpperCase()).map(
    (code) => {
      const name = names?.of(code);
      return { value: code, label: name && name !== code ? `${code} – ${name}` : code };
    },
  );
}

function supported(key: 'timeZone' | 'currency', fallback: string[]): string[] {
  try {
    const values = Intl.supportedValuesOf(key);
    return values.length > 0 ? values : fallback;
  } catch {
    return fallback;
  }
}

function withCurrent(values: string[], current?: string | null): string[] {
  if (!current || values.includes(current)) return values;
  return [...values, current].sort();
}

function currencyNames(): Intl.DisplayNames | null {
  try {
    return new Intl.DisplayNames(['de'], { type: 'currency' });
  } catch {
    return null;
  }
}
